
import request from "@/utils/request";
import config from "@/config";
// let serveUrl = config.baseUrl;
let serveUrl = 'https://portal-service.hzau.edu.cn/';
let personalCenterBaseUrl = config.personalCenterBaseUrl;

let adminCenterUrl = config.adminCenterUrl;

// 获取考生信息
export function getKsInfo(data) {
  return request({
    url: `${serveUrl}portalCenter/api/open/v1/account/defaultSfzh?ksh=${data.ksh}&name=${data.name}`,
    method: "get",
	  headerType: "open"
  });
}
